import React from "react";
import useWindowDimensions from "../../../get-diemensions/UseWindowDiemensions";
import { colors } from "../../../themes/Colors";

const Footer = () => {
  const { width, height } = useWindowDimensions();
  return (
    <div
      style={{
        width: width,
        maxWidth: 1440,
        backgroundColor: colors.bgPrimary,
        minHeight: 550,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          height: 80,
          alignItems: "center",
          justifyContent: "center",
          marginTop: 80,
        }}
      >
        <div style={{ width: "80%" }}>
          <img
            alt="main logo"
            src={require("../../../images/logos/Alter-Pharm Logo Final 1.png")}
            style={{ height: 50 }}
          />
          <div style={{ display: "flex", width: "100%", marginTop: 30 }}>
            <div
              style={{
                width: "50%",
                height: 1,
                backgroundColor: colors.primary,
              }}
            />{" "}
            <div
              style={{
                width: "50%",
                height: 1,
                backgroundColor: colors.secondary,
              }}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          marginTop: 10,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ width: "80%", display: "flex" }}>
          <div
            style={{
              flex: 0.5,
              minHeight: 300,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <div style={{ fontSize: 13, marginTop: 30 }}>About</div>
            <div style={{ fontSize: 13 }}>Legality</div>
            <div style={{ fontSize: 13 }}>Pharmacies</div>
            <div style={{ fontSize: 13 }}>Collection Points</div>
            <div style={{ fontSize: 13 }}>Contact</div>
            <div style={{ fontSize: 13 }}>Sign Up</div>
            <div style={{ fontSize: 10 }}>
              Copyright © Alter-Pharm 2025 all rights reserved
            </div>
          </div>
          <div
            style={{
              flex: 0.5,

              minHeight: 200,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              justifyContent: "space-between",
            }}
          >
            <div style={{ marginTop: 30, fontSize: 18, fontWeight: "bold" }}>
              Contact
            </div>
            <div style={{ fontSize: 13 }}>hello@alterpharm.co.za</div>
            <div style={{ fontSize: 13 }}>+27 12 345 6789</div>
            <div
              className=" identifier"
              style={{
                width: 250,
                maxWidth: 250,
                minWidth: 250,
                height: 54,
                minheight: 54,
                maxHeight: 54,
                borderRadius: 8,
                backgroundColor: colors.white,
                display: "flex",
                alignItems: "center",
                marginRight: 5,
              }}
            >
              <img
                alt="CUMCS Logo"
                src={require("../../../images/landing/CUMCS 1.png")}
              />
              <img
                alt="SAHPHRA Logo"
                src={require("../../../images/landing/image002 (1) 1.png")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
